import { type ReactNode, useState } from 'react'

interface TableScrollBoxProps {
	/**
	 * Render the table with the box element — pass it to react-virtuoso's
	 * `customScrollParent` so the table virtualizes and scrolls inside the box.
	 */
	children: (scrollParent: HTMLElement | undefined) => ReactNode
}

/**
 * Scroll container for the desktop marquee tables: fills its parent and scrolls
 * the table (both axes) inside itself.
 *
 * Contract: the parent must be a flex column with a bounded height (e.g.
 * `l:max-h-[60dvh] flex flex-col` with this box in a `flex-1 min-h-0` slot), so
 * `flex-1` caps the box instead of letting the table grow the page.
 */
export function TableScrollBox({ children }: TableScrollBoxProps) {
	const [el, setEl] = useState<HTMLDivElement | null>(null)
	return (
		<div className='min-h-0 flex-1 overflow-auto' ref={setEl}>
			{children(el ?? undefined)}
		</div>
	)
}
